var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M20.352 6.784H14.4C14.656 8.064 14.784 10.24 14.784 11.968C14.784 15.424 14.784 41.024 14.784 47.168C14.784 52.416 17.536 54.656 22.464 55.552C25.088 56 28.928 56.128 32.704 56.128C39.68 56.128 49.28 55.68 54.848 54.848V48.96C49.536 50.368 39.744 51.072 32.96 51.072C29.824 51.072 26.496 50.88 24.512 50.496C21.376 49.92 20.032 49.088 20.032 45.76C20.032 41.152 20.032 15.424 20.032 11.968C20.032 10.176 20.16 8.32 20.352 6.784Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M17.5 6.5C17.5 48.5 17 49 18.5 51C20 53 33 55.5 55.5 52",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M17.664 32.32V27.008C25.344 25.344 37.696 21.568 45.056 18.368C47.04 17.536 48.896 16.64 50.688 15.488L52.992 20.608C51.136 21.376 48.832 22.4 46.912 23.104C38.976 26.368 25.6 30.336 17.664 32.32Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M17 29.5C31.3345 26.5318 39.0328 23.6935 52 18",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi);
export default __webpack_public_path__ + "static/media/hi.0c8fdf4c46e9620e64400df1f620245e.svg";
export { ForwardRef as ReactComponent };